import storageKeys from './storageKeys';

// Private mode or blocked storage just means no prompt
const attempt = (fn, fallback) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

const appDownloadPrompt = {
  show: () => attempt(() => window.localStorage.setItem(storageKeys.appDownloadPrompt, 'true')),
  isShown: () => attempt(() => window.localStorage.getItem(storageKeys.appDownloadPrompt) !== null, false),
  hide: () => attempt(() => window.localStorage.removeItem(storageKeys.appDownloadPrompt)),
};

export default appDownloadPrompt;
